var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_vm._v("COMENTARIOS ACERCA DEL PACIENTE")]),_c('app-comments',{attrs:{"url":("dental_client_" + _vm.client_id)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }